/* istanbul ignore file */
import { number as codecNumber, oneOf as codecOneOf, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MaxDynamoSubmissionSizeSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('MAX_DYNAMO_SUBMISSION_SIZE')],
    [
        'value',
        /* #__PURE__ */ parsers.maybeNull(
        /* #__PURE__ */ codecOneOf([codecNumber, codecString])),
    ],
]);
export class MaxDynamoSubmissionSizeSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MaxDynamoSubmissionSizeSettingParser.decode(input).map(res => new MaxDynamoSubmissionSizeSetting(res));
    }
    static unsafeDecode(input) {
        return MaxDynamoSubmissionSizeSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MaxDynamoSubmissionSizeSettingParser.encode(data);
    }
    static schema() {
        return MaxDynamoSubmissionSizeSettingParser.schema();
    }
}
